/*
constraints.ts

Este archivo se encarga de manejar los constraints (resortes).
*/

import Matter, { Constraint } from "matter-js";
import { SimulationEngine } from "../core/SimulationEngine";
import { BubbleEntity } from "../entities/BubbleEntity";
import { ClusterEntity } from "../entities/ClusterEntity";


export function createClusterConstraintAtIndex(clusterBody: Matter.Body, internalBubbles: BubbleEntity[], index: number): Matter.Constraint {
    const bubble = internalBubbles[index];
    // Radio de formación: distancia del centro del cluster a la que orbita cada burbuja atrapada.
    // Se basa en el radio real (ya reducido) de la burbuja para escalar bien en pantallas chicas.
    const formationRadius = bubble._radius;
    const totalBubbles = internalBubbles.length;

    // Calcular la posición exacta (Offset) para esta burbuja
    let offsetX = 0;
    let offsetY = 0;

    if (totalBubbles > 1) {
        // 360 grados (2 * PI) entre el número de burbujas,
        // Math.PI / 2 para que la primera burbuja siempre quede arriba (a las 12 en punto)
        const angle = (index * (Math.PI * 2) / totalBubbles) - (Math.PI / 2);

        offsetX = Math.cos(angle) * formationRadius;
        offsetY = Math.sin(angle) * formationRadius;
    }

    // resorte dirigido específicamente a la coordenada local del cluster
    const constraint = Constraint.create({
        bodyA: clusterBody,
        // pointA es una coordenada local RELATIVA al centro del cluster (bodyA)
        pointA: { x: offsetX, y: offsetY },

        bodyB: bubble._body,
        // pointB es el centro de la burbuja
        pointB: { x: 0, y: 0 },

        // CRÍTICO: length 0 obliga a la burbuja a ir EXACTAMENTE a la coordenada calculada
        length: 0,

        // FÍSICAS DE VIAJE:
        // Stiffness define qué tan fuerte es el imán (0.02 - 0.05 es ideal para viajes suaves desde lejos)
        stiffness: 0.04,

        // Damping frena la burbuja a medida que llega, eliminando la vibración
        damping: 0.15,

        render: { visible: false }
    });
    return constraint;
}

export function addClusterConstraintsToWorld(engine: SimulationEngine, constraints: Matter.Constraint[]): void {
    engine._AddPhysicsObject(constraints);
}

export function recreateClusterConstraints(engine: SimulationEngine, cluster: ClusterEntity, internalBubbles: BubbleEntity[], primaryBubble?: BubbleEntity | null): Matter.Constraint[] {
    deleteConstraintsFromWorld(engine, cluster._GetConstraints());
    cluster._ReleaseBubbles(); // Liberar burbujas actuales (sin eliminar del DOM, solo sueltan el cluster)
    cluster._SetBubbles(internalBubbles, primaryBubble); // Actualiza las burbujas internas del cluster
    cluster._CaptureBubbles(); // Burbujas nuevas marcadas como atrapadas
    return cluster._GetConstraints(); // Devuelve los nuevos constraints para agregarlos al mundo
}

export function deleteConstraintsFromWorld(engine: SimulationEngine, constraints: Matter.Constraint[]): void {
    engine._RemovePhysicsObject(constraints);
}
